import { React } from 'react';
import PropTypes from 'prop-types';
import { useUpdateTeacherReportOptionsMutation } from '../../../../../features/authentication/persistApiSlice';
import CustomToast from '../../../../../components/Toast';
import { Col, Row } from 'react-bootstrap';

const ReportOptions = (props) => {
  const [updateTeacherReportOptions] = useUpdateTeacherReportOptionsMutation();

  const updateReportOptions = async (unansweredAsIncorrect, retryScore, displayName, displayId) => {
    if(!props.isSingleStudent )
    {
      if(!displayName && !displayId)
      {
        CustomToast('Either Student Name or Student Id checkbox must be selected.','warning');
        return;
      }
      props.setDisplayName(displayName);
      props.setDisplayId(displayId);
    }
    
    let options={
      incompleteScoring: unansweredAsIncorrect,
      retryScore: retryScore,
      displayName: displayName,
      displayId: displayId
    };
    await updateTeacherReportOptions(options);
    await props.updateAssignmentDetails(null, null, retryScore, unansweredAsIncorrect);
  };
  
  return (
    <Row id="reportOptions" className={`report-options m-0 ${!props.expand ? 'd-none' : ''}`}>
      <label className='fw-medium'>Report Options</label>
      <Col className='mt-3'>
        <Row id="unansweredAsIncorrect">
          <Col>
            <input
              type="checkbox"
              className="form-check-input me-2 cursor-pointer border-secondary"
              checked={props.unansweredAsIncorrect}
              id="scoreInCompleteCheck"
              name="scoreInComplete"
              onChange={() => {
                updateReportOptions(!props.unansweredAsIncorrect, props.retryScore, props.displayName, props.displayId); 
                props.setUnansweredAsIncorrect(!props.unansweredAsIncorrect);
              }}
            />
            <label className="form-check-label">
              Score unanswered questions as incorrect
            </label>
          </Col>
        </Row>
        <Row className='pt-4'>
          <Col id="retryScoring">
            <label>Corrent-On-Retry Scoring</label>
            <Row className="pt-2 mt-1">
              <Col className='col-3 d-flex'>
                <input
                  type="radio"
                  className="form-check-input cursor-pointer border-secondary me-2"
                  checked={props.retryScore === 1}
                  id="noCredit"
                  name="retriesRadioBtn"
                  onChange={() => {
                    updateReportOptions(props.unansweredAsIncorrect, 1, props.displayName, props.displayId); 
                    props.setRetryScore(1);
                  }}
                />
                <label className="form-check-label">
                  No credit
                </label>
              </Col>
              <Col className='col-3 d-flex'>
                <input
                  type="radio"
                  className="form-check-input cursor-pointer border-secondary me-2"
                  checked={props.retryScore === 2}
                  id="halfCredit"
                  name="retriesRadioBtn"
                  onChange={() => {
                    updateReportOptions(props.unansweredAsIncorrect, 2, props.displayName, props.displayId); 
                    props.setRetryScore(2);
                  }}
                />
                <label className="form-check-label">
                  Half credit
                </label>
              </Col>
              <Col className='col-3 d-flex'>
                <input
                  type="radio"
                  className="form-check-input cursor-pointer border-secondary me-2"
                  checked={props.retryScore === 3}
                  id="fullCredit"
                  name="retriesRadioBtn"
                  onChange={() => {
                    updateReportOptions(props.unansweredAsIncorrect, 3, props.displayName, props.displayId); 
                    props.setRetryScore(3);}}
                />
                <label className="form-check-label">
                  Full credit
                </label>
              </Col>
            </Row>
          </Col>
          <Col id="displayNameId">
            {!props.isSingleStudent &&
            <>
              <label>Display student as</label>
              <Row className="d-flex pt-2 mt-1">
                <Col className='col-3'>
                  <input
                    type="checkbox"
                    className="form-check-input me-2 cursor-pointer border-secondary"
                    checked={props.displayName}
                    id="studentNameCheck"
                    name="studentName"
                    onChange={() => {
                      updateReportOptions(props.unansweredAsIncorrect, props.retryScore, !props.displayName, props.displayId); 
                    }}
                  />
                  <label className="form-check-label">
                    Student Name
                  </label>
                </Col>
                <Col className='col-3'>
                  <input
                    type="checkbox"
                    className="form-check-input me-2 cursor-pointer border-secondary"
                    checked={props.displayId}
                    id="studentIdCheck"
                    name="studentId"
                    onChange={() => {
                      updateReportOptions(props.unansweredAsIncorrect, props.retryScore, props.displayName, !props.displayId); 
                    }}
                  />
                  <label className="form-check-label">
                    Student ID
                  </label>
                </Col>
              </Row>
            </> 
            }
          </Col>
        </Row>
        <Row>
          <Col>
            <p className='m-0 pt-3 fw-light'>(determines how the scores are calculated)</p>
          </Col>
        </Row>
      </Col>
    </Row> 
  );
};

ReportOptions.propTypes = {
  expand: PropTypes.bool,
  isSingleStudent: PropTypes.bool,
  retryScore: PropTypes.number,
  setRetryScore: PropTypes.func,
  unansweredAsIncorrect: PropTypes.bool,
  setUnansweredAsIncorrect: PropTypes.func,
  displayName: PropTypes.bool,
  setDisplayName: PropTypes.func,
  displayId: PropTypes.bool,
  setDisplayId: PropTypes.func,
  updateAssignmentDetails: PropTypes.func
};

export default ReportOptions;
